import { render, staticRenderFns } from "./ColorCalibration.vue?vue&type=template&id=52ed1ed3&scoped=true&"
import script from "./ColorCalibration.vue?vue&type=script&lang=js&"
export * from "./ColorCalibration.vue?vue&type=script&lang=js&"
import style0 from "./ColorCalibration.vue?vue&type=style&index=0&id=52ed1ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed1ed3",
  null
  
)

export default component.exports